<template>
    <main-content with_go_back_bar>
        <create-item-form>
        </create-item-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import Form from './components/form'


    export default {
        components: {
            'main-content': mainContent,
            'create-item-form': Form
        },
    }
</script>
